// extracted by mini-css-extract-plugin
export default {"container":"Info_container__n8v5v","header":"Info_header__fcM85","divider":"Info_divider__uyjkB","text":"Info_text__QVLSM","space":"Info_space__eop9c"};